export default "__VITE_ASSET__curDBszQ__"